export default __webpack_public_path__ + "static/media/opensea.ba697b64.png";